import { Grid } from '@mui/material'
import { Box } from '@mui/system';

import React, { useState,useRef } from 'react'
import Arrow from "../../assets/arrow.png"
import Back from "../../assets/back.png"
import logo from '../../assets/dd-logo.png';
import Zip from '../../assets/zip.png';
import TextFieldInput from 'components/textField';
import SelectInput from 'components/selectInput';
import DatePickerComponent from 'components/datePicker';
import ButtonComponent from 'components/button';
import TextareaComponent from 'components/textArea';
import { downloadBrochure, generateOTP, uploadResumeOncloud, registerUser, uploadResume, verifyOTP } from 'services/FormRegistrationService';
import validator from 'validator'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import FileInput from 'components/fileInput';

export default function Form({ onNextStep, onPrevStep, onFormSubmission }) {
    const options = [
        { value: "Male", label: 'Male' },
        { value: "Female", label: 'Female' },
    ];
    const code = [
        { value: "+91", label: '+91' },
        { value: "+61", label: '+61' },
        { value: "+1", label: '+1' },
        { value: "+43", label: '+43' },
        { value: "+64", label: '+64' },
        { value: "+971", label: '+971' },
    ];

    const year = [
        { value: "Year of passing", label: 'Year of passing' },
        { value: "2018", label: '2018' },
        { value: "2019", label: '2019' },
        { value: "2020", label: '2020' },
        { value: "2021", label: '2021' },
        { value: "2022", label: '2022' },
        { value: "2023", label: '2023' },
        { value: "2024", label: '2024' },
    ];

    const countries = [
        { value: "Select your Country", label: 'Select your Country' },
        { value: "India", label: 'India' },
    ];

    const cities = [
        { value: "City", label: 'City' },
        { value: "Pune", label: 'Pune' },
        { value: "Ahmednagar", label: 'Ahmednagar' },
        { value: "Solapur", label: 'Solapur' },
        { value: "Satara", label: 'Satara' },
        { value: "Raigad", label: 'Raigad' },
        { value: "Thane", label: 'Thane' },
        { value: "Kolhapur", label: 'Kolhapur' },
        { value: "Nashik", label: 'Nashik' },
        { value: "Jalna", label: 'Jalna' },
        { value: "Amravati", label: 'Amravati' },
        { value: "Aurangabad", label: 'Aurangabad' },
        { value: "Lonavala & Khandala", label: 'Lonavala & Khandala' },
    ];

    const skills = [
        { value: "Software Engineering beginner level skills", label: 'Software Engineering beginner level skills' },
        { value: "Java", label: 'Java' },
        { value: "Python", label: 'Python' },
        { value: "JavaScript", label: 'JavaScript' },
    ];

    const [currentStep, setCurrentStep] = useState(1);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [gender, setGender] = useState('Male');
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [mobileCode, setMobileCode] = useState('+91');
    const [mobileNo, setMobileNo] = useState('');
    const [emailId, setEmailId] = useState('');
    const [education, setEducation] = useState('');
    const [yearOfPassing, setYearOfPassing] = useState('');
    const [country, setCountry] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [skillLevel, setSkillLevel] = useState('');
    const [tellus, setTellus] = useState('');
    const [file, setFile] = useState()
    const [otp, setOtp] = useState('');
    const [enableOTP, setEnableOTP] = useState(false);
    const [verifiedOTP, setVerifiedOTP] = useState(false);
    const [OTPverificationMessage, setOTPVerificationMessage] = useState('')
    const [isEmptyField, setIsEmptyField] = useState(false);
    const [validEmail, setValidEmail] = useState(true);
    const [validMobileNo, setValidMobileNo] = useState(true);
    const [formSubmitted,setFormSubmitted]  = useState(false);
    const [feedbackMessage,setFeedbackMessage] = useState({status:'',message:''});
    const[resumeUploaded, setResumeUploaded] =useState({uploaded:false, message:'', isUploadTried:false});

    const ref = useRef('');
    const ref2 = useRef('');


    const validateEmail = (email) => {
        if (validator.isEmail(email)) {
            setValidEmail(true);
        } else {
            setValidEmail(false);
        }
    }



    const checkALLFieldsFilled = (step) => {
        if (step == 1) {
            return firstName.length > 0 &&
                lastName.length > 0 &&
                gender.length > 0 &&
                dateOfBirth!=null &&
                mobileCode.length > 0 &&
                mobileNo.length > 0 &&
                emailId.length > 0;
        }
        else if (step == 2) {
            return education.length > 0 &&
                yearOfPassing.length > 0 &&
                country.length > 0 &&
                address.length > 0 &&
                city.length > 0 &&
                zipcode.length > 0;
        }
        else {
            return skillLevel.length > 0;

        }

    }
    const handleNextStep = () => {
        if (checkALLFieldsFilled(currentStep)) {
            if (validEmail && validMobileNo && verifiedOTP) {
                setCurrentStep(currentStep + 1);
                onNextStep(currentStep + 1);
            }
            setIsEmptyField(false);
        }
        else {
          
            setIsEmptyField(true)
        }
    };

    const handleFirstNameChange = (event) => {
        setFirstName(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }
    }
    const handleLastNameChange = (event) => {
        setLastName(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }
    }
    const handleGenderChange = (event) => {
        setGender(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }
    }
    const handleDateOfBirthChange = (value) => {
        setDateOfBirth(value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }
    }
    const getOTP=async(value)=>{
        if (!verifiedOTP) {
            let data = {
                "phone": '' + mobileCode + value
            }
            const response = await generateOTP(data);
            if (response?.status == 200 && response?.data?.message == 'OTP sent status SUCCESSFUL') {
                console.log('OTP sent status SUCCESSFUL');
                setEnableOTP(true);
                setValidMobileNo(true);
                setOTPVerificationMessage('OTP sent')
            }
            else{
                setOTPVerificationMessage('Failed to sent OTP')
            }
        }
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }
    }
    const handleMobileNoChange = (event) => {
        setOTPVerificationMessage('  ')
        setMobileNo(event.target.value);
        if (event.target.value.length == 10 && Number.isInteger(+event.target.value)) {
            console.log('generate otp');
           
            getOTP(event.target.value);
        }
        else if(!Number.isInteger(+event.target.value)){
            setValidMobileNo(false);
        }
        else {
            setVerifiedOTP(false);
            setEnableOTP(false);
            setOtp('');
        }
        if (event.target.value.length != 10 && isEmptyField) {
            setValidMobileNo(false);
            setVerifiedOTP(false);
        }
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    const handleOTPChange = async (event) => {
        setOTPVerificationMessage('   ')
        setOtp(event.target.value);
        if (event.target.value.length == 5) {
            console.log('verify otp');
            let data = {
                "phone": '' + mobileCode.substring(1) + mobileNo,
                "otp": event.target.value
            }
            const response = await verifyOTP(data);
            console.log(response);
            if (response?.status == 200) {
                setVerifiedOTP(true);
                setOTPVerificationMessage(response?.data?.message)
            }
            else {
                setVerifiedOTP(false);
                setOTPVerificationMessage(response?.data?.message)
            }

        }
        else if(event.target.value.length >5){
            setVerifiedOTP(false);
            setOTPVerificationMessage('Invalid OTP')
        }
        if(enableOTP && !verifiedOTP && mobileNo.length<10){
            setEnableOTP(false)
            setOTPVerificationMessage('')
        }
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
   
    const handleEmailIdChange = (event) => {
        setEmailId(event.target.value);
        validateEmail(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    const handleEducationChange = (event) => {
        setEducation(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    const handleYearOfPassingChange = (event) => {
        setYearOfPassing(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    const handleCountryChange = (event) => {
        setCountry(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    const handleAddressChange = (event) => {
        setAddress(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    const handleCityChange = (event) => {
        setCity(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    const handleZipcodeChange = (event) => {
        setZipcode(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    const handleSkillLevelChange = (event) => {
        console.log(event);
        setSkillLevel(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    const handleTellusChange = (event) => {
        setTellus(event.target.value);
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }
    async function handleResumeChange(event) {
            setResumeUploaded(false);
            const selectedFile = event.target.files[0];
            setFile(selectedFile);
            console.log(selectedFile);
            if(selectedFile){
            let response= await uploadResume(mobileNo);

            if(response?.data?.url && response?.data?.fields && event?.target?.files[0]){
                
                let result = await uploadResumeOncloud(response.data.url,response.data.fields,event.target.files[0]);
                console.log(result);

                if(result.status>=200 && result.status<400)
                {
                    setResumeUploaded({uploaded:true,message:''});
                    
                }
                else{
                    setResumeUploaded({uploaded:false, message:result?.message});
                }

            }
            
        }
           
      }

    const handleBackStep = () => {
        setCurrentStep(currentStep - 1);
        onPrevStep(currentStep - 1);
    };
    const handlePhoneCodeChange = (event) => {
        setMobileCode(event.target.value)
        if (checkALLFieldsFilled(currentStep) && isEmptyField) {
            setIsEmptyField(false)
        }

    }

    const handleFormSubmit = () => {
        if (checkALLFieldsFilled(currentStep)) {
            let month=(dateOfBirth.month()+1)<10?('0'+(dateOfBirth.month()+1)):(dateOfBirth.month()+1);
            let year = dateOfBirth.year();
            let date = dateOfBirth.date()<10?('0'+dateOfBirth.date()):(dateOfBirth.date());
            console.log(year+'-'+month+'-'+date);
            let data = {
                "name": firstName + ' ' + lastName,
                "gender": gender,
                "dob": year+'-'+month+'-'+date,
                "mobile": mobileCode.substring(1) + mobileNo,
                "email": emailId,
                "education": education,
                "yearOfPassing": yearOfPassing,
                'address': address + ',' + city + ',' + zipcode + ',' + country,
                "skillLevel": skillLevel,
                "tellus": tellus,
            }
            console.log(data);
             registerUser(data).then((res)=>{
                console.log(res)
                
               setFeedbackMessage({status:res?.status,message:res?.data?.message})
               if(res?.status>=200 &&res?.status<300){
                setIsEmptyField(false);
                resetForm();
                setFormSubmitted(true);
                onFormSubmission();
               }
               
             })
            
        }
        else {
            setIsEmptyField(true)
        }


    }
    const resetForm = () => {
        setCurrentStep(1);
        setFirstName('');
        setLastName('');
        setGender('Male');
        setDateOfBirth('');
        setMobileCode('+91');
        setMobileNo('');
        setOtp('');
        setEmailId('');
        setEducation('');
        setYearOfPassing('');
        setCountry('');
        setAddress('');
        setCity('');
        setZipcode('');
        setSkillLevel('');
        setTellus('');
        setEnableOTP(false);
        setVerifiedOTP(false);
        setOTPVerificationMessage('')
        setIsEmptyField(false);
        setValidEmail(true);
        setValidMobileNo(true);
    }

    const handleDownloadBrochure = () =>{
        downloadBrochure(feedbackMessage?.message)
    }

   if(formSubmitted){
    return (
            <Box className="submission-status">
                <Box className="WelcomeBox">
                <h1>{feedbackMessage.status>=200 && feedbackMessage.status<400 ?'Form Submitted Successfully! ':feedbackMessage?.message}</h1>
                <h3 className='feedback-message'> We appreciate your interest in our course.The respective team will contact you shortly</h3>
                </Box>
                {feedbackMessage.status>=200 && feedbackMessage.status<400 &&
                <Box>
                    <ButtonComponent 
                    sx={{minWidth:'fit-content'}}
                     classname="btnZip"
                     onClick={handleDownloadBrochure}>
                    Download brochure 
                    <img src={Zip} style={{height: '100%'}} alt="" />
                     </ButtonComponent>
                </Box>
                }
                      <Box className="WelcomeBox">
                      <h3 className='brochure-validity'>The above download link is valid for one hour</h3>
                      </Box>
                
            </Box>
    )
   }

    return (
        <>
            <Box className="WelcomeBox">
                <img src={logo} alt="" />
                {currentStep === 1 && <> <h1>Welcome</h1>
                    <h6>DD Tech Solutions, the one stop solution for your technical learning!</h6> </>}
            </Box>
            <Box className="activeBox">
                {currentStep === 1 && <h5>Personal Information</h5>}
                {currentStep === 2 && <> <Box className="backBtn" onClick={handleBackStep}> <img src={Back} alt="" /> <h3>Back</h3> </Box><h5 className={currentStep === 2 && "activeLink"}>Education and Address</h5> </>}
                {currentStep === 3 && <> <Box className="backBtn" onClick={handleBackStep}> <img src={Back} alt="" /> <h3>Back</h3> </Box><h5 className={currentStep === 3 && "activeLink"}>Additional Information</h5> </>}
                <Box>
                    <span className={currentStep === 1 ? "indicator active" : "indicator"}></span>
                    <span className={currentStep === 2 ? "indicator active" : "indicator"}></span>
                    <span className={currentStep === 3 ? "indicator active" : "indicator"}></span>
                </Box>
            </Box>
            <Grid container spacing={2} className="layoutBoxed" justifyContent={'space-between'} sx={{ marginTop: "0 !important" }}>
                {currentStep === 1 && (
                    <>
                        <Grid item xs={12} xl={6} lg={6} md={6}>
                            <TextFieldInput inputRef={ref} value={firstName} label="First Name" className="registerInput" onChange={handleFirstNameChange} />
                        </Grid>
                        <Grid item xs={12} xl={6} lg={6} md={6}>
                            <TextFieldInput inputRef={ref2}  value={lastName} label="Last Name" className="registerInput" onChange={handleLastNameChange} />
                        </Grid>
                        <Grid item xs={12} xl={6} lg={6} md={6} className="inputSection">
                            <SelectInput value={gender} data={options} className="your-custom-class" defaultValue="Male" onChange={handleGenderChange} />
                        </Grid>

                        <Grid item xs={12} xl={6} lg={6} md={6} className='datepickerBox'>
                            <DatePickerComponent value={dateOfBirth} classname="datePicker" onChange={handleDateOfBirthChange} />
                        </Grid>

                        <Grid item xs={12} xl={verifiedOTP?3:enableOTP?3:4} lg={verifiedOTP?3:enableOTP?3:4} md={verifiedOTP?2:enableOTP?2:2} >
                            <SelectInput 
                           data={code} value={mobileCode} 
                        //    className="countryCode" 
                           defaultValue="+91" 
                           onChange={handlePhoneCodeChange}
                            className="your-custom-class countryCode" 
                          />
                        </Grid>
                        <Grid item xs={verifiedOTP?10:12} xl={verifiedOTP?8:enableOTP?5:8} lg={verifiedOTP?8:enableOTP?5:8} md={verifiedOTP?9:enableOTP?6:10}>
                        <TextFieldInput
                         value={mobileNo} 
                         sx={{width:'100%'}}
                         inputProps={{ maxLength: 10 }} 
                         label="Phone Number" 
                         className="registerInput" 
                         onChange={handleMobileNoChange} />  
                        </Grid>
                        {verifiedOTP && 
                        <Grid item xs={2} xl={1} lg={1} md={1} sx={{display:'flex',justifyContent:'left',alignItems:'center'}} >
                           <CheckCircleIcon fontSize='large' className="verfiedOTP"/>
                        </Grid>}
                        {!verifiedOTP && enableOTP && 
                        <Grid item xs={10} xl={3} lg={3} md={3} >
                            <Box sx={{position:'relative'}}>
                            <TextFieldInput 
                            onChange={handleOTPChange} 
                            sx={{width:'100%'}} 
                            name= 'contact' 
                            label="OTP" 
                            className="registerInput" />
                            {!verifiedOTP && enableOTP && <p className='otpMessage'>{OTPverificationMessage}</p>}
                            </Box>
                        </Grid>}
                        {!verifiedOTP && enableOTP && 
                        <Grid item xs={2} xl={1} lg={1} md={1} sx={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                            <RefreshIcon fontSize='large' className='refresh' onClick={()=>getOTP(mobileNo)}/>
                        </Grid>}
    
                        <Grid item xs={12} xl={12} lg={12} md={12}>
                            <TextFieldInput value={emailId} label="Email Id" className="emailInput" onChange={handleEmailIdChange} />
                        </Grid>
                    </>
                )}
                {currentStep === 2 && (
                    <>
                        <Grid item xs={12} xl={6} lg={6} md={6}>
                            <TextFieldInput value={education} label="Education" className="registerInput" onChange={handleEducationChange} />
                        </Grid>
                        <Grid item xs={12} xl={6} lg={6} md={6}>
                            <SelectInput value={yearOfPassing} data={year} className="your-custom-class" defaultValue="Year of passing" onChange={handleYearOfPassingChange} />
                        </Grid>
                        <Grid item xs={12} xl={12} lg={12} md={12}>
                            <SelectInput value={country} data={countries} className="citySelect" defaultValue="Select your Country" onChange={handleCountryChange} />
                        </Grid>
                        <Grid item xs={12} xl={12} lg={12} md={12}>
                            <TextFieldInput value={address} label="Your address" className="emailInput" onChange={handleAddressChange} />
                        </Grid>
                        <Grid item xs={12} xl={6} lg={6} md={6}>
                            <SelectInput data={cities} value={city} className="your-custom-class" defaultValue="City" onChange={handleCityChange} />
                        </Grid>
                        <Grid item xs={12} xl={6} lg={6} md={6}>
                            <TextFieldInput value={zipcode} label="Zip Code" className="registerInput" onChange={handleZipcodeChange} />
                        </Grid>

                    </>
                )}
                {currentStep === 3 && (
                    <>
                        <Grid item xs={12} xl={12} lg={12} md={12}>
                            <SelectInput data={skills} value={skillLevel} className="citySelect" defaultValue="Software Engineering beginner level skills" onChange={handleSkillLevelChange} />
                        </Grid>
                        <Grid item xs={12} xl={12} lg={12} md={12}>
                            <TextareaComponent value={tellus} onChange={handleTellusChange} />
                        </Grid>
                        <Grid item xs={10} xl={8} lg={8} md={4} className='file-upload'>
                            <FileInput  onChange={handleResumeChange}/>
                        </Grid>
                        <Grid item xs={2} xl={4} lg={4} md={8} className='file-upload'>
                            {resumeUploaded.uploaded && <CheckCircleIcon fontSize='large' sx={{marginLeft:'10px'}} className="verfiedOTP"/>}
                        </Grid>
                    </>
                )}
                <Grid item xs={12} xl={12} lg={12} md={12}>
                        {isEmptyField && <p className='emptyFieldmessage'>All fields are required</p>}
                        {!isEmptyField && !validMobileNo && <p className='emptyFieldmessage'>Enter Valid Phone Number</p>}
                        {enableOTP && validMobileNo && otp.length < 1 && <p className='emptyFieldmessage'>Type OTP to verify Number</p>}
                        {!isEmptyField && !validEmail && <p className='emptyFieldmessage'>Enter Valid Email Id</p>}
                        { feedbackMessage.status>=400 && <p className='emptyFieldmessage'>{feedbackMessage.message}</p>} 
                        {resumeUploaded.isUploadTried && !resumeUploaded.uploaded && <p className='emptyFieldmessage'>{resumeUploaded.message}</p>}
                        </Grid>
                <Grid item xs={12} xl={12} lg={12} md={12} sx={{ width: "100%" }}>
                    {currentStep < 3 ? (<> 
                        <ButtonComponent classname="btnSave" onClick={handleNextStep}>
                            Save information and next <img src={Arrow} alt="" />
                        </ButtonComponent>
                    </>

                    ) : (
                        <Box sx={{ textAlign: "center" }}>
                            <ButtonComponent disabled={file==null || file=='' || file=='undefine'} classname="btnSave" onClick={handleFormSubmit}>
                                Register
                            </ButtonComponent>
                            {/* <ButtonComponent classname="btnZip">Download the brochure <img src={Zip} alt="" /> </ButtonComponent> */}
                            
                        </Box>
                    )}
                </Grid>
            </Grid>

        </>
    )
}

